/**
 * Meta Pixel (Facebook Pixel).
 *
 * PIXEL_ID debe ser el ID numérico del pixel (15-16 dígitos) que aparece en
 * Meta Events Manager. Mientras esté vacío, el pixel no se carga.
 */
export const PIXEL_ID = '1770558240926259'

type FbqFn = ((...args: unknown[]) => void) & {
  queue?: unknown[]
  callMethod?: (...args: unknown[]) => void
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFn
    _fbq?: FbqFn
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || !PIXEL_ID || typeof window === 'undefined') return
  initialized = true

  const fbq: FbqFn = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as FbqFn

  if (!window.fbq) {
    window.fbq = fbq
    window._fbq = fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
) {
  if (!PIXEL_ID || typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
